<script>
	import { createEventDispatcher } from "svelte";
	import { uiText } from "../lib/uiText.js";
	import {
		doc,
		getDoc,
		getDocs,
		collection,
		addDoc,
		setDoc,
		updateDoc,
		arrayUnion,
		onSnapshot,
		deleteField,
		serverTimestamp,
		increment,
		query,
		limit,
		orderBy,
		where,
	} from "firebase/firestore";
	import TeamView from "./TeamView.svelte";
	import GMChatWidget from "./GMChatWidget.svelte";
	// import QrCode from './QRCode.svelte';

	const dispatch = createEventDispatcher();

	// export let auth;
	export let db;
	export let storage;
	export let lang;
	export let loader;
	export let user;
	console.log(user);
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
	$: loader, dispatch("loader", loader), (ui = uiText(lang));
	$: screen, dispatch("screen", screen);
	$: teamsPerPage,
		sessionStorage.setItem("teamsPerPage", teamsPerPage > 0 ? teamsPerPage : 1);

	let screen = "input"; //input or showcase

	let openSet = {
		gid:
			sessionStorage.getItem("latestGID") === null
				? ""
				: sessionStorage.getItem("latestGID"),
		period_from: new Date().toISOString().split("T")[0],
		// period_from: new Date(),
		period_to: new Date().toISOString().split("T")[0],
		// period_to: new Date(),
	};

	let size = 16;
	let logo_size = 14;
	let hashtag_size = 12;
	let controls = false;

	let teams = [];
	let gameName = "";
	let hashtag = "#ПравимГрадскиИгри";

	let teamsPerPage =
		sessionStorage.getItem("teamsPerPage") === null
			? 10
			: sessionStorage.getItem("teamsPerPage");
	let showUsers = true;
	let showCurrentRiddle = true;
	let showFinish = false;
	let showTime = false;
	let showInOrder = false;

	let geoOverwrite = false;
	let editVariant = false;
	let manualPoints = false;

	let chatControls = false;
	let activeChats = []; // Array to hold the teams the GM is currently chatting with

	//todo: add a second button and second type, where it shows all sessions, even those before the game has started.

	async function handleShowcase() {
		const showGameRef = query(
			collection(db, "sessions"),
			limit(teamsPerPage),
			where("orderGID", "==", openSet.gid),
			orderBy("orderSessionCreated", "desc"),
		);

		// 		.collection("sessions")
		// .orderBy("orderSessionCreated", "desc")

		sessionStorage.setItem("latestGID", openSet.gid);
		const unsubscribe = onSnapshot(showGameRef, (querySnapshot) => {
			let querySet = [];
			querySnapshot.forEach((doc) => {
				// const source = doc.metadata.hasPendingWrites ? "Local" : "Server";
				// console.log(source);
				//
				// let from = Math
				// 	.round
				// 	// openSet.period_from.toISOString().split("T")[0].getTime() / 1000
				// 	();
				// let to = Math
				// 	.round
				// 	// openSet.period_to.toISOString().split("T")[0].getTime() / 1000
				// 	();
				// let session = doc.data().orderSessionCreated.seconds;
				// if (source === "Server") {
				// if (session > from && session < to) {
				querySet.push(doc.data());

				// 	console.log(doc.data());
				// } else {
				// 	querySet.push(doc.data());
				// }
				// с;
				// }

				// console.log(doc.data().orderSessionCreated.seconds);
				// console.log(openSet.period_from);
				// console.log(Math.round(openSet.period_from.getTime() / 1000));
				// // console.log(
				// 	Math.round(
				// 		openSet.period_to.toISOString().split("T")[0].getTime() / 1000
				// 	)
				// );

				//
				// querySet.push(doc.data());
			});
			// teams = [""];
			// teams.length = 0;
			teams = querySet;
			gameName = querySet[0].game.name;
		});
		if (openSet.gid.length >= 2) {
			screen = "showcase";
			dispatch("screen", screen);
		}
	}

	async function handleExodus(e) {
		console.log(e.detail); // .session

		let sessionID;
		const gameRef = query(
			collection(db, "sessions"),
			where("access_code", "==", e.detail.session),
			limit(1),
		);

		const querySnapshot = await getDocs(gameRef);
		if (querySnapshot.size) {
			querySnapshot.forEach((doc) => {
				sessionID = doc.id;
				updateSessionOperation(sessionID, "exodus");
				// updateSession(sessionID, 0, true);
			});
		} else {
			alert("no such doc");
		}
	}

	async function handleChangeLimit(e) {
		// console.log(e.detail); // .number & .session

		let sessionID;
		const gameRef = query(
			collection(db, "sessions"),
			where("access_code", "==", e.detail.session),
			limit(1),
		);

		const querySnapshot = await getDocs(gameRef);
		if (querySnapshot.size) {
			querySnapshot.forEach((doc) => {
				sessionID = doc.id;
				updateSessionOperation(sessionID, "limit", e.detail.number);
				// updateSession(sessionID, e.detail.number, false);
			});
		} else {
			alert("no such doc");
		}
	}

	async function handleGeoOverwrite(e) {
		let sessionID;
		const gameRef = query(
			collection(db, "sessions"),
			where("access_code", "==", e.detail.session),
			limit(1),
		);

		const querySnapshot = await getDocs(gameRef);
		if (querySnapshot.size) {
			querySnapshot.forEach((doc) => {
				sessionID = doc.id;
				updateSessionOperation(sessionID, "geolock", e.detail.state);
				// updateSession(sessionID, e.detail.number, false);
			});
		} else {
			alert("no such doc");
		}
	}

	async function handleManualPoints(e) {
		let sessionID;
		const gameRef = query(
			collection(db, "sessions"),
			where("access_code", "==", e.detail.session),
			limit(1),
		);

		const querySnapshot = await getDocs(gameRef);
		if (querySnapshot.size) {
			querySnapshot.forEach((doc) => {
				sessionID = doc.id;
				updateSessionOperation(sessionID, "manual", e.detail.manual);
				// updateSession(sessionID, e.detail.number, false);
			});
		} else {
			alert("no such doc");
		}
	}
	async function handleVariant(e) {
		let sessionID;
		const gameRef = query(
			collection(db, "sessions"),
			where("access_code", "==", e.detail.session),
			limit(1),
		);

		const querySnapshot = await getDocs(gameRef);
		if (querySnapshot.size) {
			querySnapshot.forEach((doc) => {
				sessionID = doc.id;
				updateSessionOperation(sessionID, "variant", e.detail.variant);
				// updateSession(sessionID, e.detail.number, false);
			});
		} else {
			alert("no such doc");
		}
	}

	// CHAT
	async function handleToggleChat(e) {
		let sessionID;
		const gameRef = query(
			collection(db, "sessions"),
			where("access_code", "==", e.detail.session),
			limit(1),
		);
		const querySnapshot = await getDocs(gameRef);
		if (querySnapshot.size) {
			querySnapshot.forEach((doc) => {
				sessionID = doc.id;
				updateSessionOperation(sessionID, "chatEnabled", e.detail.state);
			});
		}
	}

	function handleOpenGmChat(e) {
		const teamData = e.detail.team;
		// Prevent opening duplicates
		if (!activeChats.find((t) => t.access_code === teamData.access_code)) {
			activeChats = [...activeChats, teamData];
		}
	}

	function closeChatWindow(accessCode) {
		activeChats = activeChats.filter((t) => t.access_code !== accessCode);
	}
	// CHAT
	// PLAYER INPUT
	async function handleTogglePlayerInput(e) {
		let sessionID;
		const gameRef = query(
			collection(db, "sessions"),
			where("access_code", "==", e.detail.session),
			limit(1),
		);
		const querySnapshot = await getDocs(gameRef);
		if (querySnapshot.size) {
			querySnapshot.forEach((doc) => {
				sessionID = doc.id;
				updateSessionOperation(sessionID, "playerInputEnabled", e.detail.state);
			});
		}
	}
	// PLAYER INPUT

	async function updateSessionOperation(sessionID, operation, details = false) {
		const joinSessionRef = doc(db, "sessions", sessionID);

		let updateData = {};
		switch (operation) {
			case "exodus":
				console.log("exodus");
				updateData = {
					current_task: "conclusion",
					"session.sessionEnd": serverTimestamp(),
					"session.ended": true,
					"session.exodus": true,
				};
				break;
			case "limit":
				console.log("limit");
				updateData = {
					["game.limit"]: increment(details),
				};
				break;
			case "geolock":
				console.log("geolock");
				updateData = {
					geoOverwrite: details,
				};
				break;
			case "manual":
				console.log("manual");
				updateData = {
					"session.manualModifier": details,
				};
				break;
			case "variant":
				console.log("variant");
				updateData = {
					teamVariant: details,
				};
				break;
			case "chatEnabled":
				console.log("chatEnabled");
				updateData = {
					chatEnabled: details,
				};
				break;
			case "playerInputEnabled":
				console.log("playerInputEnabled");
				updateData = {
					playerInputEnabled: details,
				};
				break;
			default:
				updateData = {};
		}

		await updateDoc(joinSessionRef, updateData, { merge: true }).then(() => {
			console.log(233);
			// if (exodusChange) {
			// handleShowcase();
			// }
			// console.log(374, 'Before doc add');
		});
	}

	// OLD update session
	// async function updateSession(sessionID, limitChange, exodusChange) {
	// 	const joinSessionRef = doc(db, "sessions", sessionID);

	// 	await updateDoc(
	// 		joinSessionRef,
	// 		exodusChange
	// 			? {
	// 					current_task: "conclusion",
	// 					"session.sessionEnd": serverTimestamp(),
	// 					"session.ended": true,
	// 					"session.exodus": true,
	// 				}
	// 			: {
	// 					["game.limit"]: increment(limitChange),
	// 				},
	// 		{ merge: true }
	// 	).then(() => {
	// 		console.log(184);
	// 		// if (exodusChange) {
	// 		// handleShowcase();
	// 		// }
	// 		// console.log(374, 'Before doc add');
	// 	});
	// }

	// For future dev:
	// let start = new Date('2017-01-01');
	// let end = new Date('2018-01-01');

	// this.afs.collection('invoices', ref => ref
	//   .where('dueDate', '>', start)
	//   .where('dueDate', '<', end)
	// );
	// https://stackoverflow.com/questions/47000854/firestore-query-by-date-range
</script>

<!--  -->
<!--  -->
<!--  -->

{#if screen == "input"}
	<p class="mt-6 uppercase">VG Panel</p>
	<h1>Game Display</h1>

	<div class="flex flex-wrap">
		<div class="grid grow">
			<label for="open-gid">GID:</label>
			<input
				type="text"
				name="open-gid"
				id="open-gid"
				bind:value={openSet.gid}
				placeholder="Open Game ID"
				title="Game ID of the game you want to open"
			/>
		</div>
		<div class="grid grow">
			<label for="open-gid">#:</label>
			<input
				type="text"
				name="open-gid"
				id="open-gid"
				bind:value={hashtag}
				placeholder="#ВътрешенГлас"
				title="#Hashtag to be shown at the bottom"
			/>
		</div>
	</div>
	<div class="flex flex-wrap">
		<div class="grid grow">
			<label for="period_from">Period from:</label>
			<input
				type="date"
				name="period_from"
				id="period_from"
				bind:value={openSet.period_from}
				placeholder="Inactive before"
				title="Inactive before"
			/>
		</div>

		<div class="grid grow">
			<label for="period_to">Period to:</label>
			<input
				type="date"
				name="period_to"
				id="period_to"
				bind:value={openSet.period_to}
				placeholder="Inactive after"
				title="Inactive after"
			/>
		</div>
	</div>

	<!-- <p>QR Content: {codeValue ? codeValue : 'Unset - Open a game to change'}</p> -->
	<!-- <button on:click={handleOpenGame}
        ><i class="fa-solid fa-folder-open" data-position="left" />Open Game</button
    > -->
	<button
		on:click={handleShowcase}
		disabled={openSet.gid.length < 3 ? true : false}
		><i class="fa-solid fa-stopwatch" data-position="left" />Showcase</button
	>
{:else if screen == "showcase"}
	<div
		class="flex flex-wrap w-screen gap-12 p-12 -mx-4 -mt-8 place-content-center"
		id="showcase"
		style={"font-size:" + size + "px"}
	>
		<div
			class="grid content-center justify-start"
			style={"font-size:" + logo_size + "px"}
		>
			<img
				class="max-w-full h-[5em]"
				src={lang === "bg" ? "/img/svg/logo-bg.svg" : "/img/svg/logo-en.svg"}
				alt={ui.game.footer.vendor}
			/>
		</div>
		<div
			class="content-center justify-end hidden ml-auto text-right sm:grid"
			style={"font-size:" + hashtag_size + "px;"}
		>
			<h1 class="font-light">
				{typeof gameName === "object" ? gameName[lang] : gameName}
			</h1>
			<h1 class="font-light text-teal">{hashtag}</h1>
		</div>
	</div>

	<div
		class="grid flex-wrap gap-2 pb-8 sm:flex"
		style={showInOrder ? "display:flex;flex-direction:column-reverse" : ""}
	>
		{#each teams as team (team.access_code)}
			<!-- {team.session.team_name} -->
			<TeamView
				{team}
				{showUsers}
				{showCurrentRiddle}
				{showFinish}
				{showTime}
				{showInOrder}
				{geoOverwrite}
				{editVariant}
				{manualPoints}
				{chatControls}
				advanced={true}
				on:changeLimit={handleChangeLimit}
				on:teamExodus={handleExodus}
				on:overwriteGeoLock={handleGeoOverwrite}
				on:changeManualModifier={handleManualPoints}
				on:changeVariant={handleVariant}
				on:toggleChat={handleToggleChat}
				on:openGmChat={handleOpenGmChat}
				on:togglePlayerInput={handleTogglePlayerInput}
			/>

			<!-- <TeamView></TeamView> -->
		{/each}
	</div>

	<!-- <button tabindex="0" class=" opacity-0">Tab In</button> -->

	<div
		class="fixed left-0 bottom-0 text-blue-100 {controls
			? 'h-0 p-0'
			: 'p-4'} display-panel"
	>
		<button
			id="controlShow"
			class="default"
			on:click={() => {
				controls = !controls;
			}}
		></button>

		<!-- <i class="mr-4 fa-solid fa-text-height" />
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-plus"
			on:click={() => (size = size + 1)}
			tabindex="0"
		/>
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-minus"
			on:click={() => (size = size - 1)}
			tabindex="0"
		/>
		| -->

		<button
			class="default py-2 px-3 text-white bg-blue-100"
			on:click={() => (screen = "input")}
			tabindex="0"><i class="fa-solid fa-square-pen" /></button
		>
		|
		<i class="mx-2 fa-brands fa-blogger-b" />
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-plus"
			on:click={() => (logo_size = logo_size + 1)}
			tabindex="0"
		/>
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-minus"
			on:click={() => (logo_size = logo_size - 1)}
			tabindex="0"
		/>

		|
		<i class="mx-2 fa-solid fa-hashtag" />
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-plus"
			on:click={() => (hashtag_size = hashtag_size + 1)}
			tabindex="0"
		/>
		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-square-minus"
			on:click={() => (hashtag_size = hashtag_size - 1)}
			tabindex="0"
		/>

		|
		<i class="p-2 fa-solid fa-list-ol" />
		<input
			class="default mx-2 my-0 p-2 w-32"
			id="teamsPerPage"
			type="number"
			min="0"
			size="4"
			bind:value={teamsPerPage}
			tabindex="0"
		/>

		<i
			class="p-2 text-white bg-blue-100 fa-solid fa-arrow-rotate-right"
			on:click={handleShowcase}
			tabindex="0"
		/>

		<!-- <i
            class="p-2 text-white bg-blue-100 fa-solid fa-square-plus"
            on:click={() => (teamsPerPage = teamsPerPage + 5)}
        />
        <i
            class="p-2 text-white bg-blue-100 fa-solid fa-square-minus"
            on:click={() => (teamsPerPage = teamsPerPage - 5)}
        /> -->
		|
		<button
			on:click={() => (showUsers = !showUsers)}
			class="default inline text-white bg-blue-100"
			tabindex="0"
		>
			<i class="p-2 fa-solid fa-user-ninja" />

			<i
				class={showUsers
					? "p-2  fa-solid fa-square-check text-white"
					: "p-2  fa-solid fa-square-xmark text-white/50"}
			/>
		</button>
		|
		<button
			on:click={() => (showCurrentRiddle = !showCurrentRiddle)}
			tabindex="0"
			class="default inline text-white bg-blue-100"
		>
			<i class="p-2 fa-solid fa-puzzle-piece" />
			<i
				class={showCurrentRiddle
					? "p-2  fa-solid fa-square-check text-white"
					: "p-2 fa-solid fa-square-xmark text-white/50"}
			/>
		</button>
		|—|
		<button
			on:click={() => (geoOverwrite = !geoOverwrite)}
			class="default inline text-white bg-blue-100"
			tabindex="0"
		>
			<i class="p-2 fa-solid fa-location-pin-lock" />
			<i
				class={geoOverwrite
					? "p-2 text-white fa-solid fa-square-check"
					: "p-2 text-white/50 fa-solid fa-square-xmark"}
			/>
		</button>
		<button
			on:click={() => (editVariant = !editVariant)}
			class="default inline text-white bg-blue-100"
			tabindex="0"
		>
			<i class="p-2 fa-solid fa-shapes" />
			<i
				class={editVariant
					? "p-2 text-white fa-solid fa-square-check"
					: "p-2 text-white/50 fa-solid fa-square-xmark"}
			/>
		</button>
		<button
			on:click={() => (manualPoints = !manualPoints)}
			class="default inline text-white bg-blue-100"
			tabindex="0"
		>
			<i class="p-2 fa-solid fa-hand" />
			<i
				class={manualPoints
					? "p-2 text-white fa-solid fa-square-check"
					: "p-2 text-white/50 fa-solid fa-square-xmark"}
			/>
		</button>

		|—|
		<button
			on:click={() => (chatControls = !chatControls)}
			class="default inline text-white bg-blue-100"
			tabindex="0"
			title="Toggle Chat Controls"
		>
			<i class="p-2 fa-solid fa-messages" />
			<i
				class={chatControls
					? "p-2 text-white  fa-solid fa-square-check"
					: "p-2 text-white/50 fa-solid fa-square-xmark"}
			/>
		</button>

		|—|
		<button
			on:click={() => (showFinish = !showFinish)}
			class="default inline text-white bg-blue-100"
			tabindex="0"
		>
			<i class="mx-4 fa-solid fa-flag-checkered" />
			<i
				class={showFinish
					? "p-2 text-white fa-solid fa-square-check"
					: "p-2 text-white/50 fa-solid fa-square-xmark"}
			/>
		</button>

		|
		<button
			on:click={() => (showTime = !showTime)}
			class="default inline text-white bg-blue-100"
			tabindex="0"
		>
			<i class="mx-4 fa-solid fa-stopwatch" />
			<i
				class={showTime
					? "p-2 text-white  fa-solid fa-square-check"
					: "p-2 text-white/50 fa-solid fa-square-xmark"}
			/>
		</button>

		<!-- <i class="fa-solid fa-stopwatch"></i> -->

		|
		<button
			on:click={() => (showInOrder = !showInOrder)}
			class="default inline text-white bg-blue-100"
			tabindex="0"
		>
			<i class="mx-4 fa-solid fa-trophy" />
			<i
				class={showInOrder
					? "p-2 text-white fa-solid fa-square-check"
					: "p-2 text-white/50 fa-solid fa-square-xmark"}
			/>
		</button>
	</div>
	<!-- <button tabindex="0" class=" opacity-0">Tab Out</button> -->
{/if}

<!-- FLOATING GM CHAT WINDOWS -->
<div
	class="fixed bottom-0 right-0 z-50 flex items-end gap-2 pr-4 pointer-events-none"
>
	{#each activeChats as chatTeam (chatTeam.access_code)}
		<div class="pointer-events-auto">
			<!-- You will create this component next -->
			<GMChatWidget
				{db}
				{storage}
				{lang}
				{user}
				gid={openSet.gid}
				team={chatTeam}
				on:close={() => closeChatWindow(chatTeam.access_code)}
			/>
		</div>
	{/each}
</div>
<div class="h-16 w-full"></div>

<style>
	#controlShow {
		height: 40px;
		padding: 0;
		width: 40px;
		padding-top: 10px;
		border-radius: 5px 5px 0 0;
		position: absolute;
		top: -40px;
		background: #fff3;
		text-align: center;
	}
	#showcase {
		grid-template-columns: auto 1fr;
		grid-template-rows: 1fr auto 1fr;
	}
	/* #showcase .qr {
    box-shadow: #093986 10px 10px 0;
  } */
	#showcase h1 {
		font-size: 3em;
		line-height: normal;
	}
	/* #showcase h1.text-6xl {
    font-size: 5em;
    line-height: normal;
    filter: drop-shadow(10px 10px 0px #093986);
    text-transform: uppercase;
    font-weight: 900;
  } */

	.display-panel {
		opacity: 1;
		background-color: #e2e8f0;
	}
</style>
